export const linkResolver = (uid, type, category = '') => {
  if (uid === 'home') return '/';
  if (type === 'page') return `/${uid}`;
  if (type === 'article') return `/insights/${category ? `${category}/` : ''}${uid}`;
  return `/${type}/${uid}`;
};
